import { render, staticRenderFns } from "./CompletedStep.vue?vue&type=template&id=15965517&"
import script from "./CompletedStep.vue?vue&type=script&lang=ts&"
export * from "./CompletedStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports